import React, { useState } from 'react';
import {ChevronDown, ChevronUp, Clock, X} from "lucide-react";
import {Service} from "../../types";
import HairStudioPlaceHolderImg from "app/assets/images/hairStudioPlaceholder.jpg";
import placeholderProverImg from "app/assets/images/ph1.jpg";
import {Avatar} from "../avatar/avatar";


interface FloatingServiceSummaryProps {
    selectedService: any | null;
    selectedAddonServices: any;
    selectedPractitioner: any | null;
    onNext: () => void;
    onRemoveAddon?: (addonId: string) => void;
    showNextButton?: boolean;
}

export const FloatingServiceSummary: React.FC<FloatingServiceSummaryProps> = ({
                                                                                  selectedService,
                                                                                  selectedAddonServices,
                                                                                  selectedPractitioner,
                                                                                  onNext,
                                                                                  onRemoveAddon,
                                                                                  showNextButton = true
                                                                              }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!selectedService) return null;

    const getTotalPrice = () => {
        console.log('selectedAddonServices',selectedAddonServices)
        const addonTotal = selectedAddonServices.reduce((sum:any, addon:any) => sum + addon.priceCents, 0);

        return (selectedService.priceCents + addonTotal)/100;
    };

    const getTotalDuration = () => {
        const addonDuration = selectedAddonServices.reduce((sum:any, addon:any) => sum + addon.duration, 0);
        return selectedService.duration + addonDuration;
    };

    const allServices = [selectedService, ...selectedAddonServices];

    return (
        <>
            {/* Backdrop when expanded */}
            {isExpanded && (
                <div
                    className="fixed inset-0 bg-black/20 z-40"
                    onClick={() => setIsExpanded(false)}
                />
            )}

            {/* Floating popup */}
            <div className={`fixed bottom-4 left-4 right-4 bg-white border border-slate-200 rounded-xl shadow-xl z-50 transition-all duration-300 ${
                isExpanded ? 'h-auto max-h-96' : 'h-20'
            }`}>

                {/* Collapsed view */}
                <div
                    className="flex items-center justify-between p-4 cursor-pointer"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className="flex items-center gap-3">
                        {selectedPractitioner?.avatar ?
                            <img
                                src={selectedPractitioner?.avatar}
                                alt={'provider'}
                                // className="w-full h-full object-cover"
                                className="w-12 h-12 rounded-full object-fill"
                            />
                            :
                            <Avatar
                                type={'character'}
                                src={''}
                                size={54}
                                name={selectedPractitioner?.name}
                            />
                        }
                        <div>
                            <h3 className="font-medium text-slate-900 text-sm">
                                {selectedService.title}
                                {selectedAddonServices.length > 0 && ` +${selectedAddonServices.length} add-on${selectedAddonServices.length > 1 ? 's' : ''}`}
                            </h3>
                            <div className="flex items-center gap-2 text-xs text-slate-500">
                                <span>${getTotalPrice()}</span>
                                <span>•</span>
                                <div className="flex items-center gap-1">
                                    <Clock className="w-3 h-3" />
                                    <span>{getTotalDuration()} min</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex items-center gap-3">
                        {isExpanded ? (
                            <ChevronDown className="w-5 h-5 text-slate-400" />
                        ) : (
                            <ChevronUp className="w-5 h-5 text-slate-400" />
                        )}

                        {showNextButton && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onNext();
                                }}
                                className="bg-blue-600 text-white px-8 py-3 rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl"
                            >
                                Next
                            </button>
                        )}
                    </div>
                </div>

                {/* Expanded view */}
                {isExpanded && (
                    <div className="border-t border-slate-100 max-h-80 overflow-y-auto">
                        <div className="p-4">
                            <h4 className="font-medium text-slate-900 mb-3">Selected Services</h4>

                            <div className="space-y-3">
                                {allServices.map((service, index) => (
                                    <div key={service.id} className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                            {service?.avatar ?
                                                <img
                                                    src={service?.avatar}
                                                    alt={'provider'}
                                                    // className="w-full h-full object-cover"
                                                    className="w-12 h-12 rounded-full object-fill"
                                                />
                                                :
                                                <Avatar
                                                    type={'character'}
                                                    src={''}
                                                    size={54}
                                                    name={service?.title}
                                                />
                                            }
                                            <div>
                                                <h5 className="font-medium text-slate-900 text-sm">
                                                    {service.title}
                                                    {index === 0 && (
                                                        <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full">
                              Main
                            </span>
                                                    )}
                                                </h5>
                                                <div className="flex items-center gap-2 text-xs text-slate-500">
                                                    <span>${service.priceCents/100}</span>
                                                    <span>•</span>
                                                    <div className="flex items-center gap-1">
                                                        <Clock className="w-3 h-3" />
                                                        <span>{service.duration} min</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {index > 0 && onRemoveAddon && (
                                            <button
                                                onClick={() => onRemoveAddon(service.id)}
                                                className="p-1 hover:bg-slate-100 rounded-full transition-colors"
                                            >
                                                <X className="w-4 h-4 text-slate-400" />
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {selectedPractitioner && (
                                <div className="mt-4 pt-4 border-t border-slate-100">
                                    <h4 className="font-medium text-slate-900 mb-2">Selected Provider</h4>
                                    <div className="flex items-center gap-3">
                                        {selectedPractitioner?.avatar ?
                                            <img
                                                src={selectedPractitioner?.avatar}
                                                alt={'provider'}
                                                // className="w-full h-full object-cover"
                                                className="w-12 h-12 rounded-full object-fill"
                                            />
                                            :
                                            <Avatar
                                                type={'character'}
                                                src={''}
                                                size={54}
                                                name={selectedPractitioner?.name}
                                            />
                                        }
                                        <div>
                                            <h5 className="font-medium text-slate-900 text-sm">{selectedPractitioner.name}</h5>
                                            <p className="text-xs text-slate-500">{selectedPractitioner.title}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="mt-4 pt-4 border-t border-slate-100">
                                <div className="flex justify-between items-center">
                                    <span className="font-medium text-slate-900">Total</span>
                                    <div className="text-right">
                                        <div className="font-bold text-lg text-blue-600">${getTotalPrice()}</div>
                                        <div className="text-xs text-slate-500">{getTotalDuration()} minutes</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
